"use strict";

import Promise from 'bluebird';
import Superagent from 'superagent';
import { browserHistory } from 'react-router';

export default function asyncFeApi(){
	return (store) => (next) => (action) => {

		if ( !action['CALL_API'] ) {
			return next(action);
		}
		
		const request = action['CALL_API'];
		const type = request.type;
		const host = process.env.NODE_ENV === 'production' ? `${location.origin}` : 'http://debug.wulink.yui.tw:3000' ;
		const header = request.header || {};
		let httpMethod = request.method;
		let target = request.target;
		let params = request.params || {};
		let namespace = '';
		
		if(/\:.+/.test(target)){
			const targetArray = target.split('/');
			let namespaceAry = [];
		
			targetArray.map(function spaceHandle(space){
				if(space){
					if(/\:.+/.test(space)){
						const name = space.replace(':', '');
						
						if(params[name]){
							namespaceAry.push(params[name]);
							delete params[name];
						}
					}else{
						namespaceAry.push(space);
					}
				}
			});
			
			namespace = '/' + namespaceAry.join('/');
		}else{
			namespace = target;
		}		
		
		return new Promise(function promiseHandle(resolve, reject){
			
			function responseCallback(responseError, response){				
				let result = {};
				
				if(responseError !== null && typeof responseError !== 'undefined'){
					result = {
						error: responseError
					};
				}else{
					try{
						result = response.body;
					}catch(bodyError){
						result = {
							error: bodyError
						};
					}
				}
				
				if( result.error ) {
					switch(result.error.status) {
						case 401:
							browserHistory.push('/home');
							break;
					}
				}

				next({
					type: type,
					response: result
				});
				
				resolve(result);
			}
			
			httpMethod = httpMethod.toLowerCase();
			target = '/api' + namespace;
			
			if(host){
				target = host + '/api' + namespace;
			}
			
			switch(httpMethod){
				case 'get':
					Superagent.get(target).query(params).set(header).end(responseCallback);
					break;
					
				case 'post':
					Superagent.post(target).send(params).set(header).end(responseCallback);
					break;
					
				case 'put':
					Superagent.put(target).send(params).set(header).end(responseCallback);
					break;
					
				case 'delete':
					Superagent.del(target).query(params).set(header).end(responseCallback);
					break;
			}
		});
	};
};


/** WEBPACK FOOTER **
 ** ./src/middleware/api.js
 **/